import { registerApplication, start } from 'single-spa'

function getAttribute (id, attribute) {
  const elem = document.getElementById(id)
  return elem ? elem.getAttribute(attribute) : ''
}

export function startSPAs () {
  // The mounting point of the vue application is within an angularjs
  // template, so we need to wait until the account app is bootstrapped
  // until we can start the vue one with single-spa.
  const element = angular.element(document.body)
  let interval = setInterval(() => {
    if (element.injector()) {
      // registering the application only after angular loads, so we
      // make sure that we have the right context in vue.

      // In order to make Angular refresh it's Title and sidebar states correctly,
      // we are registering two single-spa applications with their own routes
      const diagnosticPatientUi = 'diagnostic-patient-ui'
      const testResultsAppRoute = 'test-results'

      const diagnosticPatientResultsUi = 'diagnostic-patient-results-ui'
      const diagnosticPatientResultsAppRoute = 'test-kits'

      registerApplication(
        testResultsAppRoute,
        () => System.import(diagnosticPatientUi),
        (location) => location.hash.startsWith(`#/${testResultsAppRoute}`)
      )

      const bffUrl = getAttribute('accountExperienceApiUrl', 'data-url')
      const widgetsUrl = getAttribute('widgetsUrl', 'data-url')
      registerApplication(
        diagnosticPatientResultsAppRoute,
        () => System.import(diagnosticPatientResultsUi),
        (location) => location.hash.startsWith(`#/${diagnosticPatientResultsAppRoute}`),
        {
          bffUrl,
          widgetsUrl
        }
      )

      // File Upload
      const fileUploadAppRoute = 'upload'
      const fileUploadUI = '@ws-patient-account-ui/file-upload'
      registerApplication(
        fileUploadAppRoute,
        () => System.import(fileUploadUI),
        (location) => location.hash.startsWith(`#/${fileUploadAppRoute}`),
        {
          bffUrl,
          widgetsUrl
        }
      )

      start()
      clearInterval(interval)
    }
  }, 100)
}

document.addEventListener('DOMContentLoaded', () => {
  startSPAs()
})
